import { gql } from "@apollo/client";

export default gql`
  query GetOperation($id: Int!) {
    operation(id: $id) {
      id
      title
      subtitle
      subType
      type
      acceptHourInNationalRoadTransports
      actor {
        id
      }
      configProps {
        internationalModal
      }
      cardConfig {
        id
        color
      }
      operationPhases {
        id
        position
        phase {
          id
          phase
          sortingLabel
          sortingOrder
          sortingPath
        }
      }
      operationAccess {
        id
        type
        canCreateProcesses
        canCreateOrders
        canSeeOrders
      }
    }
  }
`;
